import { render, staticRenderFns } from "./AddChoir.vue?vue&type=template&id=624205fb&scoped=true&"
import script from "./AddChoir.vue?vue&type=script&lang=ts&"
export * from "./AddChoir.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "624205fb",
  null
  
)

export default component.exports